import { render, staticRenderFns } from "./NrcCustomerAutocomplete.vue?vue&type=template&id=a5d6bd62&"
import script from "./NrcCustomerAutocomplete.vue?vue&type=script&setup=true&lang=js&"
export * from "./NrcCustomerAutocomplete.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports